
    import Vue from 'vue';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import ivaConditionService from '@/apps/shared/services/ivaConditions-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import phoneValidateService from '@/apps/shared/services/phone-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default Vue.extend({
        components: { WhatsApp, XBreadcrumb },
        name: 'TravelAssistancePolicyOwner',
        data() {
            return {
                planDescription: '',
                planPrice: '',
                planPriceArs: '',
                covers: [],
                departureDateFormatted: '',
                returnDateFormatted: '',
                breadcrumbItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Datos del Contratante', path: '/asistencia-viajero/contratante' },
                ],
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                documentTypeList: [{ id: "", text: "" }],
                ivaConditionList: [{ id: "", text: "" }],
                maxSelections: 2,
                docTypeSelected: null,
                numDoc: null,
                firstName: "",
                lastName: "",
                nacimiento: null,
                stringDate: "",
                areaCode: null,
                telephone: null,
                email: null,
                selectedIvaCondition: null,
                isPersonExist: false,
                activeForm: false,
                activeFormPersonNoExist: false,
                searchButtonDisable: true,
                nextButtonDisable: true,
                messageErrorAge: null,
                messageErrorDigits: null,
                accept: true,
                smallSize: "small",
                isContractorTraveling: true,
                contractorBeneficiaries: 'legalHeirs',
                policyOwner: null,
                referente: null,
            }
        },
        created() {
            window.globalThis.validateNumDoc = (val) => {
                let valid = true;
                let message = "";
                if (!this.docTypeSelected) {
                    return { valid: false, message: "Debe seleccionar un tipo de documento." };
                }
                val = String(val || "").trim();
                let numericVal = val.replace(/\D/g, "");
                if (this.docTypeSelected.id === 'D') {
                    if (numericVal.length !== 7 && numericVal.length !== 8) {
                        this.searchButtonDisable = true;
                        message = numericVal.length > 0 ? "La cantidad de dígitos es incorrecta." : "Este campo es obligatorio.";
                        valid = false;
                    } else {
                        this.searchButtonDisable = false;
                        valid = true;
                    }
                } else {
                    this.searchButtonDisable = false;
                }
                if (!val) { this.searchButtonDisable = true; }
                return { valid, message };
            };
        },
        methods: {
            formatDate(date) {
                if (!date) return '';
                var d = new Date(date);
                return d.getDate().toString().padStart(2, '0') + '/' + (d.getMonth() + 1).toString().padStart(2, '0') + '/' + d.getFullYear();
            },

            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                } catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit('show-service-fail', statusCode, [() => this.pageCustomization()]);
                }
            },

            getDocumentType() {
                documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length != 0) {
                        this.documentTypeList = response.map(element => ({ ...element, id: element["id"], text: element["name"] }));
                        this.docTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                    }
                })
            },

            getIvaConditions() {
                ivaConditionService.getIvaConditionsList().then(response => {
                    if (response.length != 0) {
                        this.ivaConditionList = response.map(element => ({ ...element, id: element["id"].toString(), text: element["name"] }));
                    }
                })
            },

            isSelectedDocumentType() {
                this.numDoc = "";
                this.searchButtonDisable = true;
            },

            searchPersonData() {
                this.getPersonByDocumentAndType();
            },

            getPersonByDocumentAndType() {
                this.activeFormPersonNoExist = false;
                var dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                NF.UI.Page.blockCustom({ message: 'Buscando datos..' });
                if (this.numDoc != null && this.numDoc != "") {
                    searchPersonService.GetSearchPersonData(this.numDoc, this.docTypeSelected.id)
                        .then(response => {
                            let result = response.searchPersonResult[0];
                            if (result != undefined && (result.firstName != "" && result.lastName != "" || result.razonSocial != undefined)) {
                                this.activeFormPersonNoExist = false;
                                this.isPersonExist = true;
                                this.activeForm = true;
                                this.nacimiento = result.birthday;
                                this.firstName = result.firstName;
                                this.lastName = result.lastName;
                                this.email = dataTabHome ? dataTabHome.email : '';
                                this.areaCode = dataTabHome ? dataTabHome.areaCode : '';
                                this.telephone = dataTabHome ? dataTabHome.telephone : '';
                                this.policyOwner = result;
                                this.selectedIvaCondition = result.ivaConditionFiscalId != null && result.ivaConditionFiscalId != 0 && result.ivaConditionFiscalId != undefined
                                    ? (this.ivaConditionList.find(o => o.id == result.ivaConditionFiscalId || o.name == result.ivaConditionFiscalId))
                                    : (this.ivaConditionList.find(o => o.id == 4 || o.name == "Consumidor Final"));
                                this.nextButtonDisable = false;
                                window.globalThis.dataLayer.push({ 'product': 'asistencia-viajero', 'event': 'cotizador-viajero-dni', 'referente': this.referente });
                            } else {
                                // Alineado a AP: si el contratante no existe en BUP, no se permite avanzar
                                this.activeForm = false;
                                this.isPersonExist = false;
                                this.activeFormPersonNoExist = false;
                                this.nextButtonDisable = true;
                                this.messageErrorAge = 'No encontramos registros con los datos ingresados. '
                                    + 'Podés contactarnos al '
                                    + '<a href="https://wa.me/5493493510404?from=numutiles" '
                                    + 'target="_blank" rel="noopener noreferrer">'
                                    + '+54 9 3493 510404</a> para ayudarte.';
                            }
                        }).then(() => NF.UI.Page.unblock());
                } else {
                    NF.UI.Page.unblock();
                }
            },

            validPhone() {
                if (this.telephone == "" && this.areaCode == "") return;
                return new Promise<any>(async (resolve) => {
                    await phoneValidateService.validatePhone(this.areaCode, this.telephone).then(o => {
                        this.messageErrorDigits = o.validCountDigit ? "" : (o.validCountDigit === false ? o.message : "");
                        resolve(o.validCountDigit);
                    });
                })
            },

            anterior() {
                sessionStorage.setItem("pressBackFromPolicyOwner", "true");
                this.$router.push({ name: 'travelAssistance-tab-three' });
            },

            siguiente() {
                NF.UI.Page.block();
                // Guardar contratante en session
                var contratante = this.policyOwner || {};
                contratante.email = this.email;
                contratante.areaCode = this.areaCode;
                contratante.telephone = this.telephone;
                contratante.firstName = this.firstName;
                contratante.lastName = this.lastName;
                contratante.ivaCondition = this.selectedIvaCondition;
                contratante.documentType = this.docTypeSelected;
                contratante.documentNumber = this.numDoc;

                sessionStorage.setItem("contratante", JSON.stringify(contratante));
                searchPersonService.SetCustomPerson("PolicyOwner", this.lastName, this.firstName);
                sessionStorage.setItem("contractorTraveling", JSON.stringify(this.isContractorTraveling));
                sessionStorage.setItem("contractorBeneficiaries", JSON.stringify(this.isContractorTraveling ? this.contractorBeneficiaries : 'legalHeirs'));

                //window.globalThis.dataLayer.push({ 'product': 'asistencia-viajero', 'event': 'cotizador-viajero-datos-contratante', 'referente': this.referente });

                this.$router.push({ name: 'travelAssistance-passengers' });
                NF.UI.Page.unblock();
            },

            openCancelModal() { this.$refs.cancelModal.open(); },
            closeCancelModal() { this.$refs.cancelModal.close(); },
            cancelAndRedirect() {
                this.closeCancelModal();
                this.$router.push({ name: 'travelAssistance-tab-One' });
            },

            loadPlanData() {
                var planData = sessionStorage.getItem("SelectedTravelPlan");
                if (planData) {
                    var plan = JSON.parse(planData);
                    this.planDescription = plan.name;
                    this.planPrice = plan.priceFormatted;
                    this.planPriceArs = plan.priceArsFormatted || '';
                    this.covers = plan.covers || [];
                }
                var travelData = sessionStorage.getItem("TravelDetailsData");
                if (travelData) {
                    var travel = JSON.parse(travelData);
                    if (travel.departureDate) this.departureDateFormatted = this.formatDate(travel.departureDate);
                    if (travel.returnDate) this.returnDateFormatted = this.formatDate(travel.returnDate);
                }
            },
        },
        watch: {
            areaCode(newVal) {
                if (newVal != null && newVal != "") this.validPhone();
                this.messageErrorDigits = "";
            },
            telephone(newVal) {
                if (newVal != null && newVal != "") this.validPhone();
                else this.messageErrorDigits = "";
            },
            numDoc(newVal) {
                if (newVal == "" || newVal == null) {
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.isPersonExist = false;
                    this.nextButtonDisable = true;
                    this.searchButtonDisable = true;
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                await this.pageCustomization();
                this.getDocumentType();
                this.getIvaConditions();
                this.loadPlanData();
                sessionStorage.setItem("ExitOrContinueModal", "true");
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
